import axios from "axios";
import route from "@/shared/ziggy/route";

export const getConceptTop = (hallId) => {
  const getConceptTopUrl = route("api.user.hall.concept.index", {
    hall: hallId,
  });
  return axios.get(getConceptTopUrl);
};

export const getConceptStaff = (hallId) => {
  const getConceptStaffUrl = route("api.user.hall.concept.staff", {
    hall: hallId,
  });
  return axios.get(getConceptStaffUrl);
};

export const getConceptPortfolio = (hallId) => {
  const getConceptPortfolioUrl = route("api.user.hall.concept.portfolio", {
    hall: hallId,
  });
  return axios.get(getConceptPortfolioUrl);
};
